exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-error {\n    height: 20px;\n    margin-bottom: 20px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/atlassian/pipelines/agent/build/src/swarm/src/app/app.component.css
// module id = ../../../../../src/swarm/src/app/app.component.css
// module chunks = main